import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ROUTES } from 'routes';
import { DepositProvider, UpdateDepositProvider, useApp } from 'providers';
import { VerticalChoicePage } from './VerticalChoicePage';
import { RegistrationPage } from './RegistrationPage';
import { VehiclePricePage } from './VehiclePricePage';
import { VehicleDescriptionPage } from './VehicleDescriptionPage';
import { VehicleVersionChoicePage } from './VehicleVersionChoicePage';
import { PhotoPage } from './PhotoPage';
import { ContactInformationPage } from './ContactInformationPage';
import { PhoneValidationPage } from './PhoneValidationPage';
import { PublicationOptionsPage } from 'pages/Deposit/PublicationOptionsPage';
import { ConfirmationPage } from './ConfirmationPage';
import { PaymentRedirectionPage } from './PaymentRedirectionPage';
import { UpdateDepositPage } from './UpdateDepositPage';
import { UpdateDepositPhoneValidationPage } from './UpdateDepositPhoneValidationPage';
import { RenewDepositPage } from './RenewDepositPage';
import { UpsellDepositPage } from './UpsellDepositPage';
import { AppContainer } from 'components';
import { DepositAction } from 'types';
import './Deposit.scss';

interface Props {
  action: DepositAction;
  reference?: string;
}

export const DepositRouter: React.FC<Props> = ({ action, reference }) => {
  const { user } = useApp();

  if (!user) {
    return null;
  }

  if (action === 'deposit') {
    return (
      <DepositProvider user={user}>
        <AppContainer>
          <main className="deposit-page">
            <Switch>
              <Route exact path={ROUTES.registration} component={RegistrationPage} />
              <Route exact path={ROUTES.vehicleType} component={VerticalChoicePage} />
              <Route exact path={ROUTES.vehicleVersionChoice} component={VehicleVersionChoicePage} />
              <Route exact path={ROUTES.vehicleDescription} component={VehicleDescriptionPage} />
              <Route exact path={ROUTES.photos} component={PhotoPage} />
              <Route exact path={ROUTES.contactInformation} component={ContactInformationPage} />
              <Route exact path={ROUTES.phoneValidation} component={PhoneValidationPage} />
              <Route exact path={ROUTES.vehiclePrice} component={VehiclePricePage} />
              <Route exact path={ROUTES.publicationOptions} component={PublicationOptionsPage} />
              <Route exact path={ROUTES.payment} component={PaymentRedirectionPage} />
              <Route exact path={ROUTES.confirmation} component={ConfirmationPage} />
              <Redirect from={ROUTES.login} to={ROUTES.registration} />
              <Redirect from={ROUTES.register} to={ROUTES.registration} />
              <Redirect to={ROUTES.registration} />
            </Switch>
          </main>
        </AppContainer>
      </DepositProvider>
    );
  } else {
    return (
      <UpdateDepositProvider user={user} action={action} reference={reference!}>
        <AppContainer>
          <main className="deposit-page">
            <Switch>
              <Route exact path={ROUTES.update()} component={UpdateDepositPage} />
              <Route exact path={ROUTES.phoneValidationUpdate()} component={UpdateDepositPhoneValidationPage} />
              <Route exact path={ROUTES.renew()} component={RenewDepositPage} />
              <Route exact path={ROUTES.upsell()} component={UpsellDepositPage} />
              <Route exact path={ROUTES.payment} component={PaymentRedirectionPage} />
            </Switch>
          </main>
        </AppContainer>
      </UpdateDepositProvider>
    );
  }
};
